import { Button } from '../components/ui/button';
import { Status } from '../components/common';
import { useLab } from '../lib/service';
import { money } from '@drama/domain';
import { activeStatuses, label } from '../shared';
import { Reconcile } from './Reconcile';
import { useSeries } from './context';

/** Every command, attempt and cost recorded for this series. */
export function HistoryTab() {
  const { detail: d, writable, act, onError } = useSeries();
  const lab = useLab();
  return (
    <div className="history-layout">
      <div className="paper-panel">
        <h2>Production history</h2>
        <p className="muted">Every request, every version, every outcome.</p>
        {d.commands
          .slice()
          .reverse()
          .map((c) => (
            <div className="history-row" key={c._id}>
              <span className="history-dot" />
              <div>
                <strong>{label(c.kind)}</strong>
                <small>{new Date(c.createdAt).toLocaleString()}</small>
                {c.error && <p className="error-text">{c.error}</p>}
              </div>
              <Status value={c.status} />
              {activeStatuses.includes(c.status) && writable && (
                <Button size="sm" variant="ghost" onClick={() => void act(() => lab.cancel(c._id))}>
                  Cancel
                </Button>
              )}
            </div>
          ))}
        {!d.commands.length && <p>No production requests yet.</p>}
      </div>
      <div className="paper-panel">
        <h3>Operation ledger</h3>
        <p className="muted">
          Usage-derived costs are estimates until confirmed by provider billing.
        </p>
        {d.jobs.map((j) => (
          <div className="ledger-row" key={j._id}>
            <div>
              <strong>{label(j.kind)}</strong>
              <small>{j.model}</small>
              {j.error && <p className="error-text">{j.error}</p>}
            </div>
            <span>
              {money(j.output?.costMicros ?? j.reservation)}
              <small>{j.output?.costBasis ?? 'reserved'}</small>
            </span>
            {j.status === 'RECONCILIATION' && lab.home?.access.role === 'owner' && (
              <Reconcile jobId={j._id} onError={onError} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
